import chroma from 'chroma-js';

import {
    breakpoints,
    color,
    radius,
    semanticColor,
    shadow,
    size,
    type
} from './tokens';

export const theme = {
    // new theme structure
    breakpoints,
    color,
    radius,
    semanticColor,
    shadow,
    size,
    type,
    // old theme but updated tokens
    borderColor: color.grey.grey_10,
    borderColorFocused: semanticColor.focus,
    borderRadius: radius.radius_5,
    borderRadius4: radius.radius_5,
    borderRadius30: radius.radius_20,
    boxShadowLarge: shadow.shadow_2,
    boxShadowThin: shadow.shadow_1,
    boxShadowPopup: shadow.shadow_2,
    desktopBreakpoint: breakpoints.desktop,
    disabledColor: semanticColor.disabled,
    fontSize: {
        small: '10px',
        regular: '12px',
        medium: '14px'
    },
    greyBackground: semanticColor.uiBackground,
    greyColor: color.grey.grey_60,
    greyPalette: {
        black: color.grey.grey_90,
        grey: color.grey.grey_60,
        grey3: color.grey.grey_30,
        grey4: color.grey.grey_20,
        grey5: color.grey.grey_10,
        grey6: color.grey.grey_0,
        grey7: color.grey.grey_0,
        grey8: color.grey.grey_10,
        grey9: color.grey.grey_0,
        background: color.grey.grey_0,
        transparent: chroma(color.grey.grey_60).alpha(0.1).css(),
        transparent05: chroma(color.grey.grey_60).alpha(0.05).css()
    },
    greyLight: color.grey.grey_0,
    inverseBackground: color.grey.grey_90,
    inverseBorderColor: color.white,
    inverseColor: color.white,
    lightGreyBackground: color.grey.grey_0,
    primaryBackground: color.white,
    primaryColor: color.grey.grey_90,
    primaryColorPalette: {
        main: color.grey.grey_90,
        transparentLight: chroma(color.grey.grey_100).alpha(0.3).css()
    },
    progressBarColor: '#66bb6a',
    rankingColors: {
        green: semanticColor.support_02,
        red: semanticColor.support_01,
        yellow: semanticColor.support_03
    },
    redColor: semanticColor.error,
    redColorPalette: {
        main: color.red.red_90,
        light1: semanticColor.error
    },
    secondaryBackground: semanticColor.primary,
    secondaryColor: semanticColor.primary,
    secondaryColorPalette: {
        main: semanticColor.primary,
        light1: color.turquoise.turquoise_50,
        light4: color.turquoise.turquoise_20,
        light7: color.turquoise.turquoise_10,
        transparent: chroma(semanticColor.primary).alpha(0.1).css(),
        transparent05: chroma(semanticColor.primary).alpha(0.05).css()
    },
    successColor: semanticColor.support_02,
    shiftStatus: {
        assigned: '#66BB6A',
        expired: '#FF8A80',
        lost: '#EF5350',
        new: '#81d4fa',
        sent: '#FB8C00',
        accepted: '#FBC02D',
        submitted: '#47C7BB',
        registered: '#42a5f5'
    },
    statusOfCompletionBackgrounds: {
        Accepted: '#fbc02d',
        Assigned: '#66BB6A',
        Expired: '#FF8A80',
        Lost: '#EF5350',
        New: '#4fc3f7',
        Progress: '#fb8c00',
        Registered: '#42a5f5',
        Submitted: '#47c7bb',
        Archived: '#adc3c7',
        Hidden: '#adc3c7'
    },
    statusOfCandidateVerificationBackgrounds: {
        Unverified: semanticColor.support_01,
        Verified: semanticColor.support_02
    },
    tertiaryBackground: semanticColor.uiBackground,
    tabletBreakpoint: breakpoints.tablet,

    userAvatarBackgrounds: [
        '#455A64',
        '#00897B',
        '#C2185B',
        '#5E35B1',
        '#0097A7',
        '#7CB342'
    ]
};

export type Theme = typeof theme;
